import '../App.css';
import axios from 'axios';
import React, {useEffect, useState} from 'react';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Box, ThemeProvider, CssBaseline, Typography, List, ListItem, Button } from "@mui/material";
import theme from "../Components/theme";
import { useLocation } from 'react-router-dom';
import { DoubleOrbit } from 'react-spinner-animated';
import 'react-spinner-animated/dist/index.css'
import Header from "../Components/Header";
import Footer from "../Components/footer";

export default function IndividualSpaceReport(){
    const { reportInformation } = useLocation().state;
    const [report, setReport] = useState([]);
    const [resultPDF, setResultPDF] = useState();

    useEffect(() => {
        GetData(reportInformation.url, "true");
        GetData(reportInformation.url, "false");
    }, []);

    async function GetData (url, command) {
        command === "true"? axios.request(`https://fathomless-wave-33104.herokuapp.com/Individual_Space_Report/`, {params : {"reportURL" : url, "command" : command}})
        .then((response) => {setReport(response.data)})
        .catch((error) => console.error(error)) 
        : (axios.request(`https://fathomless-wave-33104.herokuapp.com/Individual_Space_Report/`, {params : {"reportURL" : url, "command" : command}, responseType: 'arraybuffer',headers: {'Accept': 'application/pdf'}})
        .then((response) => {setResultPDF(new Blob([response.data], {type: 'application/pdf'}))})
        .catch((error) => console.error(error)))
        
    }

    const getdate = (data) => {
        return{
            year : data.split("T")[0].split("-")[0],
            month : new Date(data.split("T")[0].split("-")[0], (parseInt(data.split("T")[0].split("-")[1]) -1).toString(), data.split("T")[0].split("-")[2]).toLocaleString("default", { month: 'long' }),
            date : data.split("T")[0].split("-")[2],
            time : data.split("T")[1].split(".")[0]
        }
    }

    const processedData = () => {
        return (<Box style={classes.landingPage}>
            <Header/>

            <Box style={classes.main} paddingLeft={2} paddingRight={2} marginTop={4}>
                <Box>
                    <Box marginBottom={4}>
                        <Typography variant='h4' fontSize={{xl: 40, lg: 35, md: 30, sm: 25, xs: 20}}>ISS Daily Summary Report</Typography>
                        <Box mt={1} mb={1}>
                            <Typography variant='h6' style={classes.date} color={"white"} fontSize={{xl: 25, lg: 21, md: 17, sm: 15, xs: 13}}>Author:</Typography>
                            <Typography variant='h6' style={classes.date} fontWeight={800} fontSize={{xl: 25, lg: 21, md: 17, sm: 15, xs: 13}} paddingLeft={1}>{report[0].authorName}</Typography>
                        </Box>
                        <Box mb={1}>
                            <Typography variant='h6' style={classes.date} color={"white"} fontSize={{xl: 25, lg: 21, md: 17, sm: 15, xs: 13}}>Date:</Typography>
                            <Typography variant='h6' style={classes.date} fontWeight={800} fontSize={{xl: 25, lg: 21, md: 17, sm: 15, xs: 13}} paddingLeft={1}>{getdate(reportInformation.publishedAt).year}/{getdate(reportInformation.publishedAt).month}/{getdate(reportInformation.publishedAt).date}</Typography>
                        </Box>
                        <Box sx={{height: "8px", backgroundColor: "white !important",borderRadius: "99px",background: "transparent",}} width={{xl: "35%", lg: "27em", md: "45%", sm: "50%", xs: "75%"}}/>
                    </Box>
                    
                    {report ? (report.map(ele => {
                        if(ele.tag === "P" ){
                            return (<Box paddingBottom={2}>
                                <Typography variant='body2' style={classes.date} fontWeight={800} fontSize={{xl: 22, lg: 19, md: 17, sm: 15, xs: 13}}>{ele.text.split(":")[0]}: </Typography>
                                <Typography variant='body2' style={classes.date}  color={"white"} fontSize={{xl: 22, lg: 19, md: 17, sm: 15, xs: 13}}>{ele.text.split(":")[1]}</Typography>
                            </Box>)
                        }else if (ele.tag === "UL"){
                            return (<List>{Array.from(ele.text.split("\n")).map(lIText =>{
                                return <ListItem><Typography variant='body2' fontSize={{xl: 22, lg: 19, md: 17, sm: 15, xs: 13}} color={"white"}>- {lIText}</Typography></ListItem >
                            })}</List>)
                        }
                })) : ("")}

                </Box>
                {resultPDF ? (
                <Box textAlign='center' mt={4} mb={4}>
                    <Button variant='outlined' align ={"center"}><a onClick={createPDF} className='Link' download = {reportInformation.title + ".pdf"} href = {window.URL.createObjectURL(resultPDF)}><Typography variant="h6" fontSize={{xl: 30, lg: 25, md: 20, sm: 17, xs: 13}}>Get PDF</Typography></a></Button>
                </Box>) :("")}
                <Box style={{ display: 'inline-flex', alignSelf: "flex-start"}} marginTop={"5vh"}>
                    <PriorityHighIcon color="primary" style={{ alignSelf: 'center', marginRight : "1%"}} sx={{ fontSize: 50}}/>
                    <Typography variant='body2' style={{ alignSelf: 'center'}} fontWeight={800} fontSize={{xl: 30, lg: 25, md: 20, sm: 17, xs: 13}}>This report was webscrapped from NASA. If you want the original go to: <a className='Link' style={{ color : "white", textDecoration : "underline "}} href={reportInformation.url}>click here</a></Typography>
                </Box>
            </Box>

            <Box textAlign='center'>
                 <Footer/>
            </Box>
        </Box>)
    }

    const createPDF = () => {
        if (resultPDF !== undefined){
            console.log(resultPDF);
        }
    
    }

    const loadingData = () => {
        return (
            <DoubleOrbit center={true} text={"Loading"}/>
        )
    }

    const classes ={
        landingPage:{
            alignItems: "center"
        },

        main:{
            minHeight: "125vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "10vh",
            marginRight: "10%"
        },
        title:{
            marginBottom: ".5em",
            
        },

        summery : {
            color : "white",
            display: 'inline',
            lineHeight: "100%",
        },

        date:{
            display: 'inline',
        }
    }

    return(<ThemeProvider theme={theme}>
            <CssBaseline />
            {report.length > 0 ? (processedData()) : (loadingData())}
    </ThemeProvider>)
};